export default __webpack_public_path__ + "static/media/underground-mine.cf32dbd9.svg";